import { FC } from 'react';
import Lozenge from '@atlaskit/lozenge';
import { TipoComentario, TipoComentarioEnum } from 'model/solicitacao/comentario/TipoComentario';

interface Props {
  tipoComentario: TipoComentario;
}

export const RotulosTipoComentario: FC<Props> = ({tipoComentario}) => {
  if (tipoComentario.id === TipoComentarioEnum.NORMAL) {
    return <></>
  } else if (tipoComentario.id === TipoComentarioEnum.AVALIACAO) {
    return <Lozenge appearance='inprogress'>Comentário da Avaliação</Lozenge>
  } else if (tipoComentario.id === TipoComentarioEnum.REABERTURA) {
    return <Lozenge appearance='inprogress'>Justificativa de reabertura</Lozenge>
  } else if (tipoComentario.id === TipoComentarioEnum.REABERTURA) {
    return <Lozenge appearance='default' isBold>Bot</Lozenge>
  }

  return <Lozenge appearance="removed" isBold>Não mapeado</Lozenge>;
}